export enum GeneralInformationMode {
    NEW = 'new',
    AUTOFILL = 'autofill',
    SAVED = 'saved',
}
